import { render, staticRenderFns } from "./QrScanner.vue?vue&type=template&id=4c20ac6e&scoped=true&"
import script from "./QrScanner.vue?vue&type=script&lang=js&"
export * from "./QrScanner.vue?vue&type=script&lang=js&"
import style0 from "./QrScanner.vue?vue&type=style&index=0&id=4c20ac6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c20ac6e",
  null
  
)

export default component.exports